import {
  React,
  Component,
  withRouter,
  RichTextEditor,
} from 'imports/CommonImports';

import textEditor from './text-editor.css';

import {PrimaryButton} from 'imports/DesignImports';

var styles = {
  editorContainer: {
    margin: '10px 30px 30px 10px',
    display: 'flex',
    flexDirection: 'column'
  },
  // TODO: ver los tamaños
  editor: {
    overflow: 'scroll',
    minHeight: '400px',
    maxHeight: '400px',
    fontFamily: 'Lato'
  },
  finishSectionContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '2em 0',
  },
}

class ProjectMethod extends Component {
  constructor(props){
    super(props);
    this.state = {
      value: RichTextEditor.createEmptyValue(),
      id: props.project.method.id,
    }
  }

  hideImageButton = () => {
    let el = document.querySelector("button[title='Image']");
    if(el != null)
      el.style.cssText = "display: none";
  }


  componentDidMount() {
    this.hideImageButton()
    this.setState({value: this.state.value.setContentFromString(this.props.project.method.text, 'html')})
  }

  onEditorChange = (value) => {
    this.props.handleMethodChange(value)
    this.setState({value});
  };

  render() {
    if(this.props.project.method.is_finished || this.props.user.position !== 'Líder de proyecto'){
      return (
        <div style={styles.editorContainer}>
        <RichTextEditor
        editorStyle={styles.editor}
        value={this.state.value}
        onChange={this.onEditorChange}
        disabled={true}
        />
        </div>
      );
    }
    return(
      <div style={styles.editorContainer}>
      <p>A continuación debes ingresar el método de cálculo utilizado para obtener el EBITDA del proyecto</p>
      <RichTextEditor
      editorStyle={styles.editor}
      value={this.state.value}
      onChange={this.onEditorChange}
      disabled={false}
      autoFocus
      placeholder={"Explica los cálculos que utilizaste para la ficha i3."}
      />
      <div style={styles.finishSectionContainer}>
        <PrimaryButton
          label="Finalizar método"
          onClick={() => this.props.finish('method', this.state.id, 'Has marcado el método de cálculo como finalizado', {text: this.state.value.toString('html')})}/>
      </div>
      </div>
    )
  }
}

export default withRouter(ProjectMethod);



// WEBPACK FOOTER //
// ./src/components/files/ProjectMethod.js